<template>
  <div class="top-panel">
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <div   class="left-image">
<!--          <el-carousel  trigger="click" :height="smallImageHeight" :interval="3000" arrow="always" :loop="true">-->
<!--            <el-carousel-item id="carousel-div" class="carousel-div" v-for="item in websitescreens.smallImages" :key="item">-->
<!--              <img ref="myInput" @load='imgOnError' class="carousel-img" :src="baseImageUrl+item" />-->
<!--&lt;!&ndash;              <el-image :src="src"></el-image>&ndash;&gt;-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->
            <!-- 上方大图轮播区域 -->
            <el-carousel
                ref="mainCarouselRef"
                :active-index="currentIndex"
                :height="smallImageHeight"
                @change="handleCarouselChange"
                :autoplay="true"
                :interval="3000"
                arrow="hover"
                indicator-position="none"
                class="main-carousel"
            >
              <el-carousel-item id="carousel-div" class="carousel-div" v-for="(item, index) in websitescreens.smallImages" :key="index">
                <img
                    @load='imgOnError'
                    class="carousel-img"
                    ref="myInput"
                    :src="baseImageUrl+item"
                    alt="轮播大图"
                    loading="lazy"
                />
              </el-carousel-item>
            </el-carousel>

            <!-- 下方小图导航区域 -->
            <div class="thumb-nav">
              <div
                  v-for="(item, index) in websitescreens.smallImages"
                  :key="index"
                  class="thumb-item"
                  :class="{ active: index === currentIndex }"
                  @click="handleThumbClick(index)"
              >
                <img
                    :src="baseImageUrl+item"
                    alt="轮播小图"
                    class="thumb-img"
                    loading="lazy"
                />
              </div>
            </div>
          </div>

      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <div class="right-info">
          <p class="product-model">{{websitescreens.modelNumber}}</p>
          <p class="product-name">{{websitescreens.name}}</p>
          <div class="operate-div">
            <div class="question-btn" @click="openPage()">{{locale[language.code].product.questionBtn}}</div>
            <div class="download-fiel-btn" @click="downloadFile()">{{locale[language.code].product.downloadBtn}}</div>
          </div>
        </div>
      </el-col>
    </el-row>


  </div>
  <div class="middle-div">
    <p class="tips-desc-title">{{locale[language.code].product.productDes}}</p>
    <el-divider></el-divider>
    <div class="middle-description">{{websitescreens.descrption}}</div>
    <div class="middle-images">
      <div class="image-div" v-for="item in websitescreens.bigImages" :key="item.id">
        <img class="middle-image"   :src="baseImageUrl+websitescreens.bigImages" />
      </div>
<!--      <img class="middle-image"   :src="baseImageUrl+websitescreens.bigImages" />-->
    </div>
    <div class="attr-table">
      <el-table  :data="attrList" stripe border class="table-desc" :cell-style="rowStyle">
        <el-table-column :label="locale[language.code].product.tableName"    prop="name" ></el-table-column>
        <el-table-column :label="locale[language.code].product.tableContent"    prop="value" ></el-table-column>
        <el-table-column :label="locale[language.code].product.tableUnit"    prop="unit" ></el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
import {
  websitescreensbyId
} from '@/api/ProductGroup';
import locale from "@/locale/locale";
import {ElMessage} from "element-plus";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Product',
  data(){
    return{
      locale:locale,
      currentIndex:0,
      hasLoad:false,
      language:null,
      smallImageHeight:400,
      websitescreens:{},
      activeName:null,
      attrList:[],
      baseImageUrl:process.env.VUE_APP_FILE_API,
      websitescreensList:[]
    }
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    var languageStr = localStorage.getItem("website-language");
    if(!languageStr){
      var intervalIndex = setInterval(() =>{
        var languageStr = localStorage.getItem("website-language");
        if(languageStr){
          clearInterval(intervalIndex);
          this.language = JSON.parse(languageStr);
          this.initData();
        }
      },100);
    }else{
      this.language = JSON.parse(languageStr);
      this.initData();
    }
  },
  methods: {
    handleCarouselChange(index){
      this.currentIndex = index
    },
    handleThumbClick(index){
      this.currentIndex = index;
      this.$refs.mainCarouselRef.setActiveItem(index);
    },
    openPage(){
      this.open = true;
      console.log("ok");
      this.$emit("updateOpen",this.open);
    },
    rowStyle(){
      return {
        'height':'50px',
        'font-size':'15px'
      }
    },
    downloadFile(){
      if(!this.websitescreens.downloadFile){
        ElMessage.error(this.locale[this.language.code].app.message.downloadTips);
      }else{
        window.open(this.baseImageUrl+this.websitescreens.downloadFile,"_blank");
      }
    },
    initData() {
      websitescreensbyId(this.$route.params.id).then(res => {
        console.log(res);
        var websitescreensList = res.data;
        for(var tempIndex in websitescreensList){
          if(websitescreensList[tempIndex].languageId == this.language.id){
            this.websitescreens = websitescreensList[tempIndex];
            break;
          }
        }

        this.websitescreens.smallImages = this.websitescreens.smallImages.split(",");
        this.websitescreens.bigImages = this.websitescreens.bigImages.split(",");


        this.attrList.push({name:"LCD Type", value:this.websitescreens.panelType, unit:""});
        this.attrList.push({name:"Display color", value:this.websitescreens.displayColor, unit:"M"});
        // this.attrList.push({name:"aspect ratio", value:this.websitescreens.aspectRatio, unit:""});
        this.attrList.push({name:"Operating temperature", value:this.websitescreens.operatingTemperatureMin+'~'+this.websitescreens.operatingTemperatureMax, unit:"℃"});
        this.attrList.push({name:"Storage temperature", value:this.websitescreens.storageTemperatureMin+'~'+this.websitescreens.storageTemperatureMax, unit:"℃"});
        this.attrList.push({name:"Module size", value:this.websitescreens.physicalSize, unit:"inch"});
        this.attrList.push({name:"Active Area(W×H)", value:this.websitescreens.activeArea, unit:"mm"});
        // this.attrList.push({name:"weight", value:this.websitescreens.weightKg, unit:"kg"});
        // this.attrList.push({name:"power consumption", value:this.websitescreens.powerConsumption, unit:"W"});
        // this.attrList.push({name:"curvature radius", value:this.websitescreens.curvatureRadius, unit:"mm"});
        // this.attrList.push({name:"refresh rate", value:this.websitescreens.refreshRate, unit:"Hz"});
        // this.attrList.push({name:"contrast ratio", value:this.websitescreens.contrastRatio, unit:"(N:1)"});
        // this.attrList.push({name:"response time", value:this.websitescreens.responseTime, unit:"ms"});
        this.attrList.push({name:"Number of Dots", value:this.websitescreens.resolutionWidth+'*'+this.websitescreens.resolutionHeight, unit:"dots"});
        this.attrList.push({name:"Power Supply Voltage", value:this.websitescreens.powerSupplyVoltage, unit:"V"});
        this.attrList.push({name:"Outline Dimensions", value:this.websitescreens.moduleSize, unit:"mm"});
        this.attrList.push({name:"Backlight", value:this.websitescreens.backlight, unit:"pcs"});
        this.attrList.push({name:"Lcm luminance", value:this.websitescreens.brightness, unit:"cd/m²"});
        this.attrList.push({name:"Interface", value:this.websitescreens.interface_, unit:""});



        this.$nextTick(() => {

        }
        );

      });
    },
    imgOnError(){

      //console.log(this.$refs.myInput[0]);
      // this.$refs.myInput[0].naturalWidth
      // this.$refs.myInput[0].clientWidth
      this.smallImageHeight = this.$refs.myInput[0].naturalHeight*this.$refs.myInput[0].clientWidth/this.$refs.myInput[0].naturalWidth+'px';
      //console.log(this.smallImageHeight);

     // this.smallImageHeight = this.$refs.myInput[0].offsetHeight+'px';
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel-div{
  padding:20px 35px;
  text-align: left;
}

.tips-desc-title{
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  padding-left: 20px;
  margin-bottom: 20px;
}

.operate-div{
  display: flex;
  flex-flow:  row nowrap;
  justify-content: center;
}

.product-model{
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  color:#636363;
}

.operate-div .question-btn{
  background-color: #1890ff;
  color:white;
  width:230px;
  height:60px;
  margin:20px 10px;
  line-height: 60px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}

.operate-div .download-fiel-btn{
  background-color: #ECECEC;
  color:#1890ff;
  width:230px;
  height:60px;
  margin:20px 10px;
  line-height: 60px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}

.top-panel{
  margin:40px 10px;
  margin-top: 100px;
}

.right-info{
  margin:5px 15px;
}

.right-info .product-name{
  font-weight: bold;
  color:#101010;
  text-align: left;
  font-size: 36px;
}

.middle-div{
  clear: both;
  margin:50px 10px;
}

.middle-description{
  text-align: left;
  margin-bottom: 30px;
  text-indent: 2ch;
  font-size: 18px;
}

.middle-images{
  margin:20px 20px;
}
.middle-images .middle-image{
  width:100%;
}

.attr-table{
  margin:20px 25px;
}

.attr-table >>> thead{

  color:white!important;
}

.attr-table >>> .el-table th.el-table__cell{
  background-color: #081eb2 !important;
}

.table-desc{
  border:1px solid #EEE;
  border-radius: 10px;
}

.main-carousel {
  padding:0px 10px;
}

.main-carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持图片比例，填充容器 */
}

/* 小图导航区域样式 */
.thumb-nav {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow-x: auto;
  padding: 5px 10px;
  /* 隐藏滚动条（美观优化） */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.thumb-nav::-webkit-scrollbar {
  display: none;
}

/* 小图项样式 */
.thumb-item {
  width: 100px;
  height: 60px;
  border: 2px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

/* 小图激活状态样式（高亮边框） */
.thumb-item.active {
  border-color: #409eff; /* Element Plus 主色调，可自定义 */
  transform: scale(1.05); /* 轻微放大，提升视觉焦点 */
}

.thumb-item:hover:not(.active) {
  border-color: #c6e2ff;
}

.thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


</style>
